import { render, staticRenderFns } from "./HistoryRecordList.vue?vue&type=template&id=c60e36ae"
import script from "./HistoryRecordList.vue?vue&type=script&lang=js"
export * from "./HistoryRecordList.vue?vue&type=script&lang=js"
import style0 from "./HistoryRecordList.vue?vue&type=style&index=0&id=c60e36ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports